import React from 'react';

var CheckMarkIcon = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "check-mark",
    height: "11",
    role: "img",
    viewBox: "0 0 14 11",
    width: "14",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "check-mark"
  }, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-2 14h18V-4H-2z",
    fill: "none"
  }), React.createElement("path", {
    d: "M4.273 10.709a.998.998 0 0 1-.707-.292L.294 7.151a.999.999 0 0 1-.001-1.414 1.002 1.002 0 0 1 1.414-.002l2.566 2.561 8.02-8.004a1.001 1.001 0 0 1 1.414 1.416L4.98 10.417a1 1 0 0 1-.707.292",
    fill: "#00C09A"
  })));
};

var ShowHideIcon = _ref2 => {
  var {
    isFocused,
    isVisible,
    titles
  } = _ref2;
  var color = isFocused ? '#0070ba' : '#000';

  if (isVisible) {
    return React.createElement("svg", {
      "aria-labelledby": "hide-icon",
      height: "13",
      role: "img",
      viewBox: "0 0 19 13",
      width: "19",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("title", {
      id: "hide-icon"
    }, titles.hide), React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, React.createElement("path", {
      d: "M-6-10h32v32H-6z"
    }), React.createElement("path", {
      d: "M9.5 13c-2.025 0-3.82-.782-5.39-1.944C2.575 9.922 1.262 8.432.153 6.97a.798.798 0 0 1 .003-.944C1.38 4.414 2.991 2.766 4.77 1.608 6.266.636 7.884 0 9.5 0c1.618 0 3.237.636 4.734 1.608 1.774 1.162 3.39 2.81 4.612 4.422a.798.798 0 0 1 0 .944c-1.109 1.458-2.422 2.952-3.954 4.082C13.321 12.218 11.526 13 9.5 13H9.5zm0-9.688c1.015 0 1.933.357 2.598.935.666.575 1.078 1.372 1.078 2.253 0 .878-.412 1.675-1.078 2.253l-.003.003c-.666.578-1.58.932-2.596.932-1.012 0-1.93-.354-2.595-.932-.666-.578-1.078-1.375-1.078-2.256 0-.878.412-1.675 1.078-2.253.668-.578 1.583-.935 2.595-.935H9.5zm1.704 1.956c-.437-.317-1.04-.51-1.705-.51s-1.268.193-1.7.507l-.005.003c-.433.314-.7.75-.7 1.233 0 .482.27.919.704 1.233.436.316 1.036.512 1.701.512.666 0 1.268-.196 1.705-.51.433-.316.704-.753.704-1.235 0-.482-.27-.917-.704-1.233zM4.797 9.851c1.38 1.02 2.945 1.707 4.702 1.707 1.757 0 3.323-.688 4.703-1.707 1.254-.929 2.36-2.13 3.323-3.347-1.085-1.347-2.443-2.68-3.923-3.643-1.317-.858-2.724-1.415-4.103-1.415-1.376 0-2.783.557-4.1 1.415-1.48.964-2.838 2.296-3.922 3.643.96 1.217 2.07 2.418 3.32 3.347z",
      fill: color,
      fillRule: "nonzero"
    })));
  }

  return React.createElement("svg", {
    "aria-labelledby": "show-icon",
    height: "16",
    role: "img",
    viewBox: "0 0 20 16",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "show-icon"
  }, titles.hide), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M-6-8h32v32H-6z"
  }), React.createElement("path", {
    d: "M18.714 9.253c-2.592 3.404-5.525 5.146-8.719 5.146a7.4 7.4 0 0 1-2.15-.34.375.375 0 0 1-.26-.5.376.376 0 0 1 .502-.261c.642.2 1.285.3 1.928.3 2.933 0 5.645-1.622 8.076-4.846a.63.63 0 0 0 0-.74c-.703-.882-1.547-1.723-2.55-2.544a.39.39 0 0 1-.06-.56c.14-.18.4-.2.561-.06 1.045.84 1.95 1.742 2.672 2.663a1.47 1.47 0 0 1 0 1.742zm-4.66-5.006l-7.976 8.51c0 .04-.02.06-.04.1a.32.32 0 0 1-.201.16L4.109 14.88a.41.41 0 0 1-.301.12c-.1 0-.201-.04-.282-.1-.16-.16-.18-.4-.02-.56l1.527-1.623a16.172 16.172 0 0 1-3.736-3.464c-.382-.5-.402-1.202-.02-1.702C3.867 4.127 6.8 2.384 9.995 2.384c1.226 0 2.491.34 3.777 1.002l2.13-2.263c.16-.16.401-.16.562-.02.16.16.18.4.02.56l-2.25 2.403s0 .02-.02.02a.61.61 0 0 1-.16.16zm-6.39 5.647L11.3 6.009a2.93 2.93 0 0 0-1.306-.32c-1.527 0-2.812 1.2-2.812 2.603 0 .58.16 1.14.482 1.602h-.001zm5.525-5.908c-1.085-.54-2.17-.8-3.194-.8-2.933 0-5.645 1.62-8.076 4.845a.601.601 0 0 0 0 .72 14.517 14.517 0 0 0 3.656 3.345l1.527-1.622a3.541 3.541 0 0 1-.743-2.182c0-1.843 1.647-3.405 3.616-3.405.663 0 1.306.18 1.888.5l1.326-1.401zm-.38 4.306c0 1.582-1.227 2.803-2.814 2.803-.221 0-.4.179-.402.4 0 .22.181.4.402.4 2.03 0 3.616-1.581 3.616-3.603a.402.402 0 0 0-.803 0z",
    fill: color,
    fillRule: "nonzero",
    stroke: color,
    strokeWidth: ".5"
  })));
};

ShowHideIcon.defaultProps = {
  titles: {
    hide: '',
    show: ''
  }
};
export { CheckMarkIcon, ShowHideIcon };